import {SET_LANGUAGE} from "../actions/app";
import {SET_ACCOUNT} from "../actions/app";
import {SET_CHAIN} from "../actions/app";
import {SET_BALANCE} from "../actions/app";

const initialState = {
    activeLanguage: localStorage.getItem('_lang') ? localStorage.getItem('_lang') : 'en',
    currentAccount: null,
    currentChain: null,
    balance: {
        TRX: 0,
        BTT: 0,
        ETH: 0,
    }
};

export function appReducer(state = initialState, action) {

    switch (action.type) {

        case SET_LANGUAGE: {
            let language = action.language;
            return {
                ...state,
                activeLanguage: language,
            };
        }

        case SET_ACCOUNT: {
            let account = action.account;
            return {
                ...state,
                currentAccount: account,
            };
        }

        case SET_CHAIN: {
            let chain = action.chain;
            return {
                ...state,
                currentChain: chain,
            };
        }

        case SET_BALANCE: {
            let balance = action.balance;
            return {
                ...state,
                balance: balance,
            };
        }

        default:
            return state;
    }
}
